import { actionTypes } from "../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MARK_ACTIVE_INACTIVE_USER_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.MARK_ACTIVE_INACTIVE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.MARK_ACTIVE_INACTIVE_USER_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.MARK_ACTIVE_INACTIVE_USER_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.MARK_ACTIVE_INACTIVE_USER_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
